import type { SagaIterator } from 'redux-saga';
import { put, select } from 'redux-saga/effects';

import { selectReceiptCenterQueries, selectShouldSyncReceiptData } from './receiptsSelectors';
import { receiptsActions } from './receiptsSlice';
import { type ReceiptCenterQueries, ReceiptSchema } from './receiptsTypes';

export function* receiptsDumpUpdater(resources: unknown[]): SagaIterator {
  yield put(receiptsActions.mergeReceipts(ReceiptSchema.array().parse(resources)));
  const center: ReceiptCenterQueries = yield select(selectReceiptCenterQueries);
  if (center.enabled) yield put(receiptsActions.fetchReceiptSummary());
}

export function* receiptsNudgeUpdater(): SagaIterator {
  const shouldSyncReceiptData: boolean = yield select(selectShouldSyncReceiptData);
  if (!shouldSyncReceiptData) {
    return;
  }

  const center: ReceiptCenterQueries = yield select(selectReceiptCenterQueries);
  if (center.enabled) {
    yield put(receiptsActions.invalidateReceiptCenter(false));
    yield put(receiptsActions.fetchReceiptSummary());
    return;
  }
  yield put(receiptsActions.fetchReceipts(undefined));
}
